import { useEffect, useState } from 'react';
import { useLocalTranslation } from '@/hooks/useLocalTranslation';
import { Modal } from 'react-bootstrap';
import { Link } from 'react-router-dom';

import { reportPrivateVideoQueryApiCall, reportPublicVideoQueryApiCall } from "@/services/api"
import "./style.css"
import { useAuthToken } from '@/hooks/useAppSelectors';
import { toast } from 'sonner';
import { useSelector } from 'react-redux';
import { RootState } from '@/store';
import { addCurrentThemeClassToEle } from '@/utils';

import LightGrayCross from "@/assets/icons/lightGrayCross.png";
import { themes } from '@/constants/colors_v2';

function ReportModal(props: any) {
    const token = useAuthToken()
    const { common } = useLocalTranslation();
    const [selected, setSelected] = useState<string>("");
    const [textareaVal, setTextareaVal] = useState<string>("");
    const [submutBtnDisable, setSubmutBtnDisable] = useState(true)
    const [isSubmitBtnLoading, setIsSubmitBtnLoading] = useState(true)
    const currentTheme = useSelector((state: RootState) => state.currentThemeReducer.currentTheme);

    const reportOptions = [
        {
            text: common.statusText.misinformation,
            value: "misInformation"
        },
        {
            text: common.statusText.missingPresentation,
            value: "missingPresentation"
        },
        {
            text: common.statusText.other,
            value: "other"
        },
    ]

    useEffect(() => {
        resetStates()
    }, [props.show])

    const resetStates = () => {
        setSelected("")
        setTextareaVal("")
        setSubmutBtnDisable(true)
        setIsSubmitBtnLoading(false)
    }

    useEffect(() => {
        unDoSubmitBtn()
    }, [textareaVal, selected])


    const handleRadioValChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const val = event.target.value
        setSelected(val);
    };

    const handleTextAreaValChange = (event: React.ChangeEvent<HTMLTextAreaElement>) => {
        const val = event.target.value
        setTextareaVal(val);
    };

    const unDoSubmitBtn = () => {
        if (textareaVal.length > 0 && selected !== "") {
            setSubmutBtnDisable(false)
        }
    }


    const handleSubmit = async () => {
        setIsSubmitBtnLoading(true)
        // const isPublic = props.videoDetails.isPublic
        const payload = {
            title: selected,
            description: textareaVal,
            videoDocId: props.videoDetails._id,
            location: "video",
        }
        let fnToUse = null

        if (token) {
            fnToUse = reportPrivateVideoQueryApiCall
        } else {
            fnToUse = reportPublicVideoQueryApiCall
        }

        if (fnToUse !== null) {
            const fnToUseStatus = await fnToUse(payload)
            if (fnToUseStatus.status) {
                toast.success(common.statusText.reportQueryVideo01)
                setTimeout(() => {
                    props.handleClose('close')
                }, 300)

            } else {
                toast.error(common.statusText.reportQueryVideo02)
                setTimeout(() => {
                    props.handleClose('close')
                }, 300)
                console.log("Issue in submiting report video query ", fnToUseStatus)
            }
        }
        setIsSubmitBtnLoading(false)
    }

    return (
        <Modal
            show={props.show}
            onHide={() => props.handleClose('close')} centered>
            <div className={`reportModal p-[20px] ${addCurrentThemeClassToEle(currentTheme, 'reportModal')}`}>


                <Modal.Header className='p-0 border-0 mb-[10px] modalHeader'>

                    {currentTheme === themes.dark ? (
                        <div className='darkThemetopCloseButtonHelperModelCon'>
                            <Modal.Title className='text-[16px] font-semibold'>
                                {common.statusText.reportVideo}
                            </Modal.Title>

                            <button
                                onClick={() => props.handleClose('close')}
                                type="button"
                                className='text-[14px]'
                                aria-label="Close">
                                <img src={LightGrayCross} alt='LightGrayCross' className='w-[14px]' />
                            </button>
                        </div>
                    ) : (
                        <>
                            <Modal.Title className='text-[16px] font-semibold'>
                                {common.statusText.reportVideo}
                            </Modal.Title>

                            <button
                                onClick={() => props.handleClose('close')}
                                type="button"
                                className='btn-close topCloseButtonHelper'
                                aria-label="Close">
                            </button>

                        </>
                    )}



                </Modal.Header>

                <Modal.Body className='p-0'>
                    <div className='modalBody'>
                        <hr />
                        {/* {apiMsg !== "" &&
                            <p className={` ${apiMsgTextColor} text-[14px] font-semibold mb-[7px]`}>{apiMsg}</p>
                        } */}
                        {reportOptions.map((option, index) => (
                            <label
                                key={index}
                                className='block reportOptionLabel'>
                                <input
                                    type="radio"
                                    name="reportOption"
                                    value={option.value}
                                    checked={selected === option.value}
                                    onChange={handleRadioValChange}
                                />
                                {" "}{option.text}
                            </label>
                        ))}

                        <textarea
                            onChange={handleTextAreaValChange}
                            className='reportTextarea'
                            maxLength={500}
                            rows={7}></textarea>

                        <p className='textareaChars'>{textareaVal.length}/500 chars</p>

                        <p className='reportNoteCon'>{common.statusText.reportText}</p>

                        <Link
                            className='reportViewOurTermsOfService'
                            to="">
                            {common.statusText.viewOurTermsOfService}
                        </Link>

                        <div className='reportFooter'>
                            <button
                                onClick={() => props.handleClose('close')}
                                className='cancleBtn'>
                                {common.statusText.cancleBtn}
                            </button>
                            <button
                                onClick={handleSubmit}
                                disabled={(submutBtnDisable || isSubmitBtnLoading)}
                                style={{
                                    cursor: (submutBtnDisable || isSubmitBtnLoading) ? 'not-allowed' : 'pointer',
                                    opacity: (submutBtnDisable || isSubmitBtnLoading) ? '0.8' : '1'
                                }}
                                className='submitBtn'>
                                {common.statusText.submitBtn}
                            </button>
                        </div>
                    </div>
                </Modal.Body>

            </div>
        </Modal>
    );
}

export default ReportModal;